import { PieChart } from '@/common/dashboard/charts/PieChart';
import { Mode } from '@/common/entityFramework/enumerations/Mode';
import { useNavState } from '@/common/navState/NavStateContext';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { ExprUtils } from '@/common/utils/ExprUtils';
import { useEffect, useState } from 'react';

export const McdInvProgressChart = ({
  selectedStates = [],
  selectedCtrts = [],
  selectedPeriod,
  selectedDueDate,
  selectedMcdInvOrigins = [],
  isCld = false,
}) => {
  const { navigateTo } = useNavState();

  const rsrc = useRsrc();
  const [data, setData] = useState();

  useEffect(() => {
    if (!selectedPeriod?.id) return;

    const stateIds = selectedStates.map((state) => state.id);
    const ctrtIds = selectedCtrts.map((ctrt) => ctrt.id);
    const mcdInvOriginNames = selectedMcdInvOrigins.map((origin) => origin.name);
    const reqParam = {
      periodId: selectedPeriod?.id,
      stateIds,
      ctrtIds,
      startDate: selectedDueDate?.startDate,
      endDate: selectedDueDate?.endDate,
      mcdInvOriginNames,
      isCld,
    };

    rsrc.data('sc', 'MCD_INV_PROGRESS_CHART_DATA_PLUGIN', reqParam).then((data) => {
      setData(data);
    });
  }, [selectedStates, selectedPeriod, selectedCtrts, selectedDueDate, selectedMcdInvOrigins, isCld]);

  const navigateToInvList = (dataPoint) => {
    const invStatustatuses = dataPoint.invStatuses;
    const invStatustatusField = isCld ? 'cldStatus' : 'sumStatus';
    let expr = ExprUtils.whereParams(invStatustatusField, invStatustatuses);

    const selectedPeriodId = selectedPeriod?.id;
    if (selectedPeriodId) {
      expr = ExprUtils.and(expr, ExprUtils.whereParams('invPeriodId', selectedPeriodId));
    }

    const selectedSateIds = selectedStates.map((state) => state.id);
    if (selectedSateIds.length > 0) {
      expr = ExprUtils.and(expr, ExprUtils.setExpr('stateId', selectedSateIds));
    }

    const selectedCtrtIds = selectedCtrts.map((ctrt) => ctrt.id);
    if (selectedCtrtIds.length > 0) {
      expr = ExprUtils.and(expr, ExprUtils.setExpr('ctrtId', selectedCtrtIds));
    }

    if (selectedDueDate?.startDate && selectedDueDate?.endDate) {
      expr = ExprUtils.and(
        expr,
        ExprUtils.effectiveDateClause('dueDate', selectedDueDate.startDate, selectedDueDate.endDate),
      );
    }
    const selectedMcdOriginNames = selectedMcdInvOrigins.map((origin) => origin.name);
    if (selectedMcdOriginNames.length > 0) {
      expr = ExprUtils.and(expr, ExprUtils.setExpr('mcdInvOrigin', selectedMcdOriginNames));
    }

    const navState = {
      mode: Mode.LIST,
      expr: expr,
    };

    navigateTo('sc/mcd-inv', navState);
  };

  if (!data || data.length === 0) return;

  return <PieChart data={data} onClick={(dataPoint) => navigateToInvList(dataPoint)} />;
};
